import{useRef as e,useEffect as r}from"../external/preact/hooks/dist/hooks.js";function t(t){const o=e();return r(()=>{o.current=t},[t]),o.current}export{t as usePrevious};
